import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const supportApi = createApi({
  reducerPath: "supportApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "communication/support",
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.userSlice?.token;
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({



    createSupport: builder.mutation({
      query: ({ ...body }) => {
        const payload = { ...body };

        return {
          url: "/",
          method: "POST",
          body: payload,
        };
      },
    }),

   
  }),
});

export const {
useCreateSupportMutation
} = supportApi;
